import { Component, OnInit } from '@angular/core';
import { PartnerInput } from '../../../models/partner-input.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { OsmosisService } from '../../services/osmosis.service';
import { SharedEngagementTableComponent } from '../../shared/engagement-table/engagement-table.component';

@Component({
  selector: 'app-customer-acknowledgment-list',
  templateUrl: './customer-acknowledgment-list.component.html',
  styleUrls: ['./customer-acknowledgment-list.component.scss'],
  standalone: true,
  imports: [SharedEngagementTableComponent]
})
export class CustomerAcknoledgmentListComponent implements OnInit {
  engagementList!: PartnerInput[];
  loading!: boolean;
  prevDocumentType!: string;

  constructor(private osm: OsmosisService) {}

  ngOnInit() {
    this.initializeCustomerAckReviewList();
    this.prevDocumentType = PreviewDocumentTypes.customerAcknowledgement;
  }

  initializeCustomerAckReviewList() {
    this.loading = true;
    this.osm.getEngagementsForCustomerAckReview().subscribe(serviceOutput => {
      this.engagementList = serviceOutput;
      this.loading = false;
    });
  }
}
